import { FC, useEffect, useRef, useState } from 'react';
import { checkPaymentStatus } from 'services/package';
import { useLocation, useNavigate } from 'react-router-dom';
import PaymentSkeleton from 'components/shared/PaymentSkeleton';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { useGetPage } from 'hooks/useGetPage';
import { b2b, showPaymentLoader } from 'constants/generic';

const PackagePaymentPage: FC = () => {
  const [paymentUrl, setPaymentUrl] = useState('');
  const [triesCount, setTriesCount] = useState(60);
  const { pathname, search } = useLocation();
  const isTour = useRef(pathname.includes('tour')).current;
  const navigate = useNavigate();
  const timeout = useRef<any>();
  useGetPage('/ilpackages/book');

  useEffect(() => {
    if (b2b) {
      if (window.location.pathname.toLowerCase() !== `/ilpackage/payment`) {
        return;
      }
    }
    const newData = sessionStorage.getItem('packagePaymentOrder');
    if (newData) {
      const data = JSON.parse(newData);
      check(data.transactionId);
      setPaymentUrl(data.paymentUrl);
    }

    return () => clearTimeout(timeout.current);
  }, [pathname]); // eslint-disable-line

  const check = async (transactionId: string) => {
    setTriesCount((prev) => prev - 1);

    const responseCheck = await checkPaymentStatus(transactionId);

    if (responseCheck?.bookingModel?.statusGoToXX) {
      navigate('/status-xx');
      sessionStorage.setItem(
        'bookStatusXX',
        JSON.stringify({
          orderId: responseCheck.bookingModel?.orderId,
          transactionId,
          url: 'ILPackages/SubmitScreenshots',
        })
      );
    } else if (responseCheck?.statusGoToMOrReq) {
      sessionStorage.setItem(
        'packageSuccessOrder',
        JSON.stringify({ ...responseCheck.bookingModel, transactionId, statusGoToMOrReq: true })
      );
      navigate(`/${isTour ? 'tour' : 'ilpackage'}/success${search}`);
    } else if (responseCheck?.orderHasBeenPaid) {
      sessionStorage.setItem(
        'packageSuccessOrder',
        JSON.stringify({ ...responseCheck.bookingModel, transactionId })
      );
      navigate(`/${isTour ? 'tour' : 'ilpackage'}/success${search}`);
    } else if (responseCheck?.hasErrors) {
      sessionStorage.setItem('errMessage', responseCheck?.errorMessage);
      sessionStorage.setItem(
        'bookFail',
        JSON.stringify({
          orderId: responseCheck.bookingModel?.orderId,
          transactionId,
          url: 'ILPackages/SubmitScreenshots',
        })
      );
      navigate('/fail');
    } else if (triesCount > 0) {
      timeout.current = setTimeout(() => check(transactionId), 5000);
    }
  };

  return (
    <div
      className="details-wrapper position-relative"
      style={{ justifyContent: 'center', height: 830 }}
    >
      
        <PaymentSkeleton systemProducts="Nofshon" showPaymentLoader={showPaymentLoader} />

      {paymentUrl && !paymentUrl.includes('<iframe') && (
        <iframe
          src={paymentUrl}
          title="pay"
          width={470}
          height={577}
          style={{ marginTop: 35, zIndex: 1 }}
        />
      )}

      {paymentUrl && paymentUrl.includes('<iframe') && (
        <div className="book-payment-wr" dangerouslySetInnerHTML={{ __html: paymentUrl }}></div>
      )}
    </div>
  );
};

export default withErrorBoundary(PackagePaymentPage, 'PackagePaymentPage');
